













































import { Component, Vue } from 'vue-property-decorator'
import * as modules from '../../../store/decorator'

@Component
export default class Agreement extends Vue {
    loading = false

    async acceptAgreement() {
        this.loading = true
        
        try {
            // Update the user's agreement status
            await this.$http.post(process.env.VUE_APP_V3_AGREE_PROC, {
                userid: modules.user.userDetail.userId
            }, {
                headers: {
                    Authorization: process.env.VUE_APP_V3_API_KEY
                }
            })
            
            // Update the store to reflect agreement acceptance
            modules.user.updateAgreementStatus(true)
            
            // Redirect to home page after successful agreement
            this.$router.push({ name: 'home' })
        } catch (error) {
            // Handle error appropriately - could show user notification here
        } finally {
            this.loading = false
        }
    }

    logout() {
        this.$auth.logout({
            redirect: { name: 'login' }
        })
    }
}
